import { PrimaryButton } from 'glints-aries/es/@next';
import { Blue } from 'glints-aries/es/@next/utilities/colors';
import styled from 'styled-components';

export const PrimaryHireLandingPageButton = styled(PrimaryButton)`
  background-color: ${Blue.S99};
`;
